import { useAuthBearerFetch } from "matsuri-hooks"
import { m2mCleaning_cleanerV2 } from "../endpoints/m2m-cleaning.cleaner-v2"

export interface Listing {
    id: string
    companyId: string
    delegatedTo: string
    name: string
    address: string
    cleanerNote: string
}

export const useListingByCleaningId = (
    token: string,
    cleaningId: string | undefined
) => {
    return useAuthBearerFetch<Listing>(
        token,
        cleaningId
            ? m2mCleaning_cleanerV2.findListingByCleaningId({ cleaningId })
            : null,
        {}
    )
}
